<!-- 取消线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
              "monthTicketBillId": 122333,
              "frozenStartTime": "20240730032102",
              "frozenEndTime": "20240803042102",
              "reason": "123"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台申请月票冻结",
                t_url: this.commonUrls.test + "applyMonthTicketFreeze",
                p_url: this.commonUrls.prod + "applyMonthTicketFreeze",
                precondition: "无",
                fitSystem: "智汇云车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketBillId', info2: '是', info3: 'Long', info4: '月票订单id' },
                        { info1: 'frozenStartTime', info2: '是', info3: 'Date', info4: '冻结开始时间 yyyyMMddHHmmss' },
                        { info1: 'frozenEndTime', info2: '是', info3: 'Date', info4: '冻结结束时间 yyyyMMddHHmmss' },
                        { info1: 'reason', info2: '是', info3: 'Long', info4: '原因' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'operator', info2: '否', info3: 'String', info4: '申请人' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/applyMonthTicketFreeze.vue